import { NgModuleRef } from '@angular/core';

/**
 * For one off components.
 * Note - not tested if you have more that one of the same component on the same page.
 * I suspect there might be a race condition and the second will not load but put an
 * error in the console.
 */
export class InteractiveContentComponentConfig {
  static readonly AUSTRALIA_FUND_PLATFORMS = new InteractiveContentComponentConfig(
    'AustraliaFundPlatforms',
    () =>
      import(
        /* webpackChunkName: "australia-fund-platforms" */ './australia-fund-platforms/australia-fund-platforms.module'
      )
  );

  static readonly CPREIF_PORTFOLIO_TOOL = new InteractiveContentComponentConfig(
    'CpreifPortfolioTool',
    () =>
      import(
        /* webpackChunkName: "cpreif-portfolio-tool" */ './cpreif-portfolio-tool/cpreif-portfolio-tool.module'
      )
  );

  static readonly POP_QUIZ = new InteractiveContentComponentConfig(
    'PopQuiz',
    () => import(/* webpackChunkName: "popquiz" */ './pop-quiz/pop-quiz.module')
  );

  static readonly RECESSION_DASHBOARD = new InteractiveContentComponentConfig(
    'RecessionDashboard',
    () =>
      import(
        /* webpackChunkName: "recession-dashboard" */ './recession-dashboard/recession-dashboard.module'
      )
  );

  static readonly WHAT_HAPPENED_LAST_WEEK = new InteractiveContentComponentConfig(
    'WhatHappenedLastWeek',
    () =>
      import(
        /* webpackChunkName: "what-happened-last-week" */ './what-happened-last-week/what-happened-last-week.module'
      )
  );

  static readonly MUNI_MAP = new InteractiveContentComponentConfig(
    'MuniMap',
    () => import(/* webpackChunkName: "munimap" */ './muni-map/muni-map.module')
  );

  static readonly PCS_TOOL = new InteractiveContentComponentConfig(
    'PcsTool',
    () => import(/* webpackChunkName: "pcstool" */ './pcs-tool/pcs-tool.module')
  );

  static readonly US_INDEX_BANNER = new InteractiveContentComponentConfig(
    'USIndexBanner',
    () =>
      import(
        /* webpackChunkName: "us-index-banner" */ './us-index/us-index-banner/us-index-banner.module'
      )
  );

  static readonly US_INDEX_PERFORMANCE = new InteractiveContentComponentConfig(
    'USIndexPerformance',
    () =>
      import(
        /* webpackChunkName: "us-index-performance" */ './us-index/us-index-performance/us-index-performance.module'
      )
  );

  static readonly US_INDEX_TOP_CONSTITUENT = new InteractiveContentComponentConfig(
    'USIndexTopConstituents',
    () =>
      import(
        /* webpackChunkName: "us-index-top-constituents" */ './us-index/us-index-top-constituents/us-index-top-constituents.module'
      )
  );

  static readonly US_INDEX_ALLOCATIONS = new InteractiveContentComponentConfig(
    'USIndexAllocations',
    () =>
      import(
        /* webpackChunkName: "us-index-allocations" */ './us-index/us-index-allocations/us-index-allocations.module'
      )
  );

  static readonly CPREIF_LOCATION_MAP = new InteractiveContentComponentConfig(
    'CpreifLocationMap',
    () =>
      import(
        /* webpackChunkName: "cpreif-location-map" */ './cpreif-location-map/cpreif-location-map.module'
      )
  );

  static readonly MIFID_CALCULATOR = new InteractiveContentComponentConfig(
    'MifidCalculator',
    () =>
      import(
        /* webpackChunkName: "mifid-calculator" */ './mifid-calculator/mifid-calculator.module'
      )
  );

  static readonly FIXED_INCOME_FINE_TUNING = new InteractiveContentComponentConfig(
    'FixedIncomeFineTuning',
    () =>
      import(
        /* webpackChunkName: "fixed-income-fine-tuning" */ './fixed-income-fine-tuning/fixed-income-fine-tuning.module'
      )
  );

  static readonly GERMAN_CALCULATOR_ONE_TIME_INVESTMENT = new InteractiveContentComponentConfig(
    'GermanOneTimeInvestmentCalculator',
    () =>
      import(
        /* webpackChunkName: "german-calculator-one-time-investment" */ './german-calculator/gc-one-time-investment/gc-one-time-investment.module'
      )
  );

  static readonly GERMAN_CALCULATOR_SAVINGS_PLAN = new InteractiveContentComponentConfig(
    'GermanSavingsPlanCalculator',
    () =>
      import(
        /* webpackChunkName: "german-calculator-savings-plan" */ './german-calculator/gc-savings-plan/gc-savings-plan.module'
      )
  );

  static readonly GERMAN_CALCULATOR_WITHDRAWL_PLAN = new InteractiveContentComponentConfig(
    'GermanWithdrawalPlanCalculator',
    () =>
      import(
        /* webpackChunkName: "german-calculator-withdrawl-plan" */ './german-calculator/gc-withdrawl-plan/gc-withdrawl-plan.module'
      )
  );

  static readonly GERMAN_CALCULATOR_PENSION = new InteractiveContentComponentConfig(
    'GermanPensionCalculator',
    () =>
      import(
        /* webpackChunkName: "german-calculator-pension" */ './german-calculator/gc-pension/gc-pension.module'
      )
  );

  static readonly RETIREMENT_LIFESTYLE_TOOL = new InteractiveContentComponentConfig(
    'RetirementLifestyleTool',
    () =>
      import(
        /* webpackChunkName: "retirement-lifestyle-tool" */ './retirement-lifestyle-tool/retirement-lifestyle-tool.module'
      )
  );

  static readonly QUOTENTIAL_QUERSTIONNAIRE = new InteractiveContentComponentConfig(
    'QuotentialQuestionnaire',
    () =>
      import(
        /* webpackChunkName: "quotential-questionnaire" */ './quotential-questionnaire/quotential-questionnaire.module'
      )
  );

  static readonly DYNAMIC_DROPDOWN = new InteractiveContentComponentConfig(
    'DynamicDropdown',
    () =>
      import(
        /* webpackChunkName: "dynamic-dropdown-tool" */ './dynamic-dropdown/dynamic-dropdown.module'
      )
  );

  static readonly NEWS_FEEDS = new InteractiveContentComponentConfig(
    'NewsFeeds',
    () =>
      import(
        /* webpackChunkName: "news-feeds-tool" */ './news-feeds/news-feeds.module'
      )
  );

  static readonly EFFECTIVE_ANNUAL_COSTS = new InteractiveContentComponentConfig(
    'SAEffectiveAnnualCosts',
    () =>
      import(
        /* webpackChunkName: "effective-annual-costs" */ './effective-annual-costs/effective-annual-costs.module'
      )
  );

  static readonly NJBEST_CONTRIBUTION_CALCULATOR = new InteractiveContentComponentConfig(
    'NJBESTContributionCalculator',
    () =>
      import(
        /* webpackChunkName: "njbest-contribution-calculator" */ './njbest/contribution-calculator/contribution-calculator.module'
      )
  );

  static readonly NJBEST_GET_STARTED = new InteractiveContentComponentConfig(
    'NJBESTGetStarted',
    () =>
      import(
        /* webpackChunkName: "njbest-get-started" */ './njbest/get-started/get-started.module'
      )
  );

  static readonly NJBEST_INVESTMENT_OPTIONS = new InteractiveContentComponentConfig(
    'NJBESTInvestmentOptions',
    () =>
      import(
        /* webpackChunkName: "njbest-investment-options" */ './njbest/investment-options/investment-options.module'
      )
  );

  static readonly NJBEST_PORTFOLIO_SELECTOR = new InteractiveContentComponentConfig(
    'NJBESTPortfolioSelector',
    () =>
      import(
        /* webpackChunkName: "njbest-portfolio-selector" */ './njbest/portfolio-selector/portfolio-selector.module'
      )
  );

  static readonly NJBEST_TREASURY_MANAGED_PRICE_AND_PERFORMANCE = new InteractiveContentComponentConfig(
    'NJBestTreasuryManagedPortfolios',
    () =>
      import(
        /* webpackChunkName: "njbest-treasury-managed-price-and-performance" */ './njbest/treasury-managed-price-and-performance/treasury-managed-price-and-performance.module'
      )
  );

  static readonly LITERATURE_AUDIT = new InteractiveContentComponentConfig(
    'LiteratureAudit',
    () =>
      import(
        /* webpackChunkName: "literature-audit" */ './literature-audit/literature-audit.module'
      )
  );

  static readonly SIMPLE_HIGHCHARTS = new InteractiveContentComponentConfig(
    'SimpleHighcharts',
    () =>
      import(
        /* webpackChunkName: "simple-highcharts" */ './simple-highcharts/simple-highcharts.module'
      ),
    true
  );

  /**
   * Add any new config to the allConfigs array.
   */
  static allConfigs: InteractiveContentComponentConfig[] = [
    InteractiveContentComponentConfig.AUSTRALIA_FUND_PLATFORMS,
    InteractiveContentComponentConfig.CPREIF_PORTFOLIO_TOOL,
    InteractiveContentComponentConfig.POP_QUIZ,
    InteractiveContentComponentConfig.RECESSION_DASHBOARD,
    InteractiveContentComponentConfig.WHAT_HAPPENED_LAST_WEEK,
    InteractiveContentComponentConfig.MUNI_MAP,
    InteractiveContentComponentConfig.US_INDEX_BANNER,
    InteractiveContentComponentConfig.US_INDEX_PERFORMANCE,
    InteractiveContentComponentConfig.US_INDEX_TOP_CONSTITUENT,
    InteractiveContentComponentConfig.US_INDEX_ALLOCATIONS,
    InteractiveContentComponentConfig.CPREIF_LOCATION_MAP,
    InteractiveContentComponentConfig.PCS_TOOL,
    InteractiveContentComponentConfig.MIFID_CALCULATOR,
    InteractiveContentComponentConfig.FIXED_INCOME_FINE_TUNING,
    InteractiveContentComponentConfig.GERMAN_CALCULATOR_ONE_TIME_INVESTMENT,
    InteractiveContentComponentConfig.GERMAN_CALCULATOR_SAVINGS_PLAN,
    InteractiveContentComponentConfig.GERMAN_CALCULATOR_WITHDRAWL_PLAN,
    InteractiveContentComponentConfig.GERMAN_CALCULATOR_PENSION,
    InteractiveContentComponentConfig.RETIREMENT_LIFESTYLE_TOOL,
    InteractiveContentComponentConfig.QUOTENTIAL_QUERSTIONNAIRE,
    InteractiveContentComponentConfig.DYNAMIC_DROPDOWN,
    InteractiveContentComponentConfig.NEWS_FEEDS,
    InteractiveContentComponentConfig.EFFECTIVE_ANNUAL_COSTS,
    InteractiveContentComponentConfig.NJBEST_CONTRIBUTION_CALCULATOR,
    InteractiveContentComponentConfig.NJBEST_GET_STARTED,
    InteractiveContentComponentConfig.NJBEST_INVESTMENT_OPTIONS,
    InteractiveContentComponentConfig.NJBEST_PORTFOLIO_SELECTOR,
    InteractiveContentComponentConfig.LITERATURE_AUDIT,
    InteractiveContentComponentConfig.NJBEST_TREASURY_MANAGED_PRICE_AND_PERFORMANCE,
    InteractiveContentComponentConfig.SIMPLE_HIGHCHARTS,
  ];

  loaded = false;
  moduleRef: NgModuleRef<unknown>; // cache loaded module in case we need it again.

  // returns matching config or undefined
  static getConfig(key: string): InteractiveContentComponentConfig {
    return this.allConfigs.find(
      (config: InteractiveContentComponentConfig): boolean => config.key === key
    );
  }

  private constructor(
    private readonly key: string,
    public readonly loader: any,
    public readonly multiple?: boolean
  ) {}
}
